import { Link } from 'src/elements/Link'
import {
  truewhite,
  _contributionborder,
  _contributionssearchtitle,
  _contributiontext,
  _inversingbuttonshadow,
} from 'src/styles/colors'
import { fontWeightBold } from 'src/styles/font'
import { inversing } from 'src/styles/mixins'
import styled, { css } from 'styled-components'

const ctaStyle = css`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px 5px;
  border-radius: 5px;
  border: 1px solid ${_contributionborder};
  width: 170px;

  font-size: 14px;
  font-weight: ${fontWeightBold};

  ${inversing({ color: _contributiontext, background: truewhite })};

  svg {
    margin-right: 8px;
    width: 18px;
    height: 1em;
  }
`

export const ContributionButton = styled.button`
  ${ctaStyle};
`

export const ContributionLink = styled(Link)`
  ${ctaStyle};
`

export const cardWidth = 400
export const cardWidthMargin = 20
export const headerBorder = 'solid #ebebeb 1px'

export const searchContainerChild = styled.div`
  width: ${cardWidth}px;
  margin: 0 ${cardWidthMargin}px;
  padding: 17px;
  border-radius: 10px;
  border: ${headerBorder};
  position: relative;
  h4 {
    font-size: 12px;
    color: ${_contributionssearchtitle};
    margin-bottom: 5px;
    white-space: nowrap;
  }
`

const CARD_WRAP_WIDTH = 1600

/**
 * When 3 columns cards changes to 2 columns
 * @param style
 */
export const cardWrapPoint = (style: ReturnType<typeof css>) => css`
  @media screen and (max-width: ${CARD_WRAP_WIDTH}px) {
    ${style};
  }
`
